(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('form[id^="ContactForm"]').forEach((contactForm) => {
    if (contactForm.dataset.prismSpamGuard === 'true') return;

    contactForm.dataset.prismSpamGuard = 'true';
    contactForm.addEventListener('submit', (event) => {
      const honeypot = contactForm.querySelector('[data-contact-honeypot]');
      const spamError = contactForm.querySelector('[data-contact-spam-error]');

      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        if (spamError) spamError.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prism-pro-team"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prism-pro-team')) {
    class PrismProTeam extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.stage = this.querySelector('[data-pro-team-stage]');
        this.rosterPage = this.querySelector('[data-roster-page]');
        this.detailPage = this.querySelector('[data-detail-page]');
        this.rosterList = this.querySelector('.prism-pro-team__roster-list');
        this.triggers = Array.from(this.querySelectorAll('[data-member-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-member-panel]'));
        this.backButton = this.querySelector('[data-team-back]');
        this.previousButton = this.querySelector('[data-member-previous]');
        this.nextButton = this.querySelector('[data-member-next]');
        this.shareButtons = Array.from(this.querySelectorAll('[data-member-share]'));
        this.position = this.querySelector('[data-member-position]');
        this.progress = this.querySelector('[data-member-progress]');
        this.status = this.querySelector('[data-team-status]');
        this.sectionKey = this.dataset.sectionId || 'pro-team';
        this.baseUrl = `${window.location.pathname}${window.location.search}`;
        this.currentIndex = 0;
        this.lastTrigger = null;
        this.rosterScrollY = window.scrollY;
        this.pointerStart = null;
        this.shareSwapTimer = null;
        this.shareResetTimer = null;
        this.spotlightFrame = null;
        this.activeSpotlight = null;
        this.spotlightMotionQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.boundResize = () => this.syncHeight();
        this.boundKeydown = (event) => this.handleKeydown(event);
        this.boundExternalEscape = (event) => {
          if (event.key === 'Escape' && !this.contains(event.target)) this.handleKeydown(event);
        };
        this.boundBlockSelect = (event) => this.handleBlockSelect(event);
        this.boundPopstate = () => this.syncFromLocation();
        this.boundSpotlightPreferenceChange = () => this.resetSpotlight();

        if (!this.stage || !this.rosterPage || !this.detailPage || this.triggers.length === 0) {
          this.syncHeight();
          return;
        }

        this.triggers.forEach((trigger, index) => {
          trigger.addEventListener('click', () => this.openMember(index, { historyMode: 'push' }));
          trigger.addEventListener('pointerenter', (event) => this.activateSpotlight(trigger, event));
          trigger.addEventListener('pointermove', (event) => this.trackSpotlight(trigger, event));
          trigger.addEventListener('pointerleave', () => this.clearSpotlight(trigger));
          trigger.addEventListener('focus', () => this.activateSpotlight(trigger));
          trigger.addEventListener('blur', () => this.clearSpotlight(trigger, true));
        });
        this.backButton?.addEventListener('click', () => this.requestRoster());
        this.previousButton?.addEventListener('click', () => this.navigateMember(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.navigateMember(this.currentIndex + 1));
        this.shareButtons.forEach((button) => {
          button.addEventListener('click', () => this.shareMember(button));
        });
        this.detailPage.addEventListener('pointerdown', (event) => this.handlePointerDown(event));
        this.detailPage.addEventListener('pointerup', (event) => this.handlePointerUp(event));
        this.detailPage.addEventListener('pointercancel', () => {
          this.pointerStart = null;
        });
        this.addEventListener('keydown', this.boundKeydown);
        this.addEventListener('shopify:block:select', this.boundBlockSelect);
        window.addEventListener('resize', this.boundResize, { passive: true });
        window.addEventListener('keydown', this.boundExternalEscape);
        window.addEventListener('popstate', this.boundPopstate);
        this.spotlightMotionQuery.addEventListener?.('change', this.boundSpotlightPreferenceChange);
        this.reducedMotionQuery.addEventListener?.('change', this.boundSpotlightPreferenceChange);
        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.boundResize, { once: true });
        });
        const initialMemberIndex = this.memberIndexFromHash();
        if (initialMemberIndex === null) {
          this.syncHeight();
        } else {
          window.requestAnimationFrame(() => {
            this.openMember(initialMemberIndex, { historyMode: 'none', focusHeading: false });
          });
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.shareSwapTimer);
        window.clearTimeout(this.shareResetTimer);
        window.cancelAnimationFrame(this.spotlightFrame);
        window.removeEventListener('resize', this.boundResize);
        window.removeEventListener('keydown', this.boundExternalEscape);
        window.removeEventListener('popstate', this.boundPopstate);
        this.spotlightMotionQuery?.removeEventListener?.('change', this.boundSpotlightPreferenceChange);
        this.reducedMotionQuery?.removeEventListener?.('change', this.boundSpotlightPreferenceChange);
        this.removeEventListener('keydown', this.boundKeydown);
        this.removeEventListener('shopify:block:select', this.boundBlockSelect);
      }

      spotlightEnabled() {
        return this.dataset.page === '1' && this.spotlightMotionQuery.matches && !this.reducedMotionQuery.matches;
      }

      activateSpotlight(trigger, event) {
        if (!trigger || !this.rosterList || !this.spotlightEnabled()) return;
        if (event?.pointerType && event.pointerType !== 'mouse') return;
        if (this.activeSpotlight !== trigger) {
          this.resetSpotlight();
          this.activeSpotlight = trigger;
          this.rosterList.dataset.spotlightActive = 'true';
          trigger.classList.add('is-spotlight');
        }
        if (event) this.trackSpotlight(trigger, event);
      }

      trackSpotlight(trigger, event) {
        if (event.pointerType !== 'mouse' || trigger !== this.activeSpotlight || !this.spotlightEnabled()) return;
        const clientX = event.clientX;
        const clientY = event.clientY;
        window.cancelAnimationFrame(this.spotlightFrame);
        this.spotlightFrame = window.requestAnimationFrame(() => {
          const bounds = trigger.getBoundingClientRect();
          if (bounds.width <= 0 || bounds.height <= 0) return;
          const x = Math.min(1, Math.max(0, (clientX - bounds.left) / bounds.width));
          const y = Math.min(1, Math.max(0, (clientY - bounds.top) / bounds.height));
          trigger.style.setProperty('--spotlight-rx', `${((0.5 - y) * 5).toFixed(2)}deg`);
          trigger.style.setProperty('--spotlight-ry', `${((x - 0.5) * 6).toFixed(2)}deg`);
          trigger.style.setProperty('--spotlight-shift-x', `${((x - 0.5) * 6).toFixed(2)}px`);
          trigger.style.setProperty('--spotlight-shift-y', `${((y - 0.5) * 4).toFixed(2)}px`);
          trigger.style.setProperty('--spotlight-shadow-x', `${((0.5 - x) * 12).toFixed(2)}px`);
          this.spotlightFrame = null;
        });
      }

      clearSpotlight(trigger, force = false) {
        if (trigger !== this.activeSpotlight) return;
        if (!force && document.activeElement === trigger) {
          this.resetSpotlightMotion(trigger);
          return;
        }
        this.resetSpotlight();
      }

      resetSpotlightMotion(trigger) {
        [
          '--spotlight-rx',
          '--spotlight-ry',
          '--spotlight-shift-x',
          '--spotlight-shift-y',
          '--spotlight-shadow-x'
        ].forEach((property) => trigger.style.removeProperty(property));
      }

      resetSpotlight() {
        window.cancelAnimationFrame(this.spotlightFrame);
        this.spotlightFrame = null;
        this.triggers?.forEach((trigger) => {
          trigger.classList.remove('is-spotlight');
          this.resetSpotlightMotion(trigger);
        });
        this.rosterList?.removeAttribute('data-spotlight-active');
        this.activeSpotlight = null;
      }

      normalizeIndex(index) {
        return ((index % this.panels.length) + this.panels.length) % this.panels.length;
      }

      openMember(index, options = {}) {
        const { historyMode = 'push', focusHeading = true } = options;
        const normalizedIndex = this.normalizeIndex(index);
        this.resetSpotlight();
        if (this.dataset.page === '1') {
          this.lastTrigger = this.triggers[normalizedIndex];
          this.rosterScrollY = window.scrollY;
        }
        this.showMember(normalizedIndex, false);
        this.dataset.page = '2';
        this.stage.dataset.page = '2';
        this.rosterPage.setAttribute('aria-hidden', 'true');
        this.rosterPage.setAttribute('inert', '');
        this.detailPage.setAttribute('aria-hidden', 'false');
        this.detailPage.removeAttribute('inert');
        if (historyMode !== 'none') this.writeMemberHistory(historyMode);
        if (focusHeading) this.detailPage.focus({ preventScroll: true });
        this.syncHeight();
        this.scrollDetailIntoView();
        if (focusHeading) {
          const activeHeading = this.panels[this.currentIndex]?.querySelector('[data-member-heading]');
          window.setTimeout(() => activeHeading?.focus(), this.prefersReducedMotion() ? 0 : 250);
        }
      }

      requestRoster() {
        if (this.ownsCurrentHistoryEntry()) {
          window.history.back();
          return;
        }
        this.clearMemberHistory();
        this.showRoster();
      }

      showRoster(options = {}) {
        const { focusTrigger = true } = options;
        const restoreScrollY = this.rosterScrollY;
        this.resetSpotlight();
        this.resetShareFeedback();
        this.dataset.page = '1';
        this.stage.dataset.page = '1';
        this.detailPage.setAttribute('aria-hidden', 'true');
        this.detailPage.setAttribute('inert', '');
        this.rosterPage.setAttribute('aria-hidden', 'false');
        this.rosterPage.removeAttribute('inert');
        this.triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.removeAttribute('aria-current');
        });
        this.syncHeight();
        window.setTimeout(() => {
          window.scrollTo({ top: restoreScrollY, behavior: 'auto' });
          if (focusTrigger) this.lastTrigger?.focus({ preventScroll: true });
        }, this.prefersReducedMotion() ? 0 : 250);
      }

      navigateMember(index) {
        this.showMember(index, true);
        this.writeMemberHistory('replace');
      }

      showMember(index, focusHeading) {
        if (this.panels.length === 0) return;
        this.resetShareFeedback();
        this.currentIndex = this.normalizeIndex(index);
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === this.currentIndex;
          panel.hidden = !active;
          panel.toggleAttribute('inert', !active);
        });
        this.triggers.forEach((trigger, triggerIndex) => {
          const active = triggerIndex === this.currentIndex;
          trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
          if (active) trigger.setAttribute('aria-current', 'true');
          else trigger.removeAttribute('aria-current');
        });
        const activePanel = this.panels[this.currentIndex];
        if (this.position) this.position.textContent = activePanel.dataset.memberStatus || '';
        if (this.progress) {
          this.progress.style.setProperty('--member-progress', `${((this.currentIndex + 1) / this.panels.length) * 100}%`);
        }
        if (this.status) this.status.textContent = activePanel.dataset.memberName || '';
        this.syncHeight();
        if (focusHeading) {
          const heading = activePanel.querySelector('[data-member-heading]');
          window.requestAnimationFrame(() => heading?.focus());
        }
      }

      currentMemberUrl(index = this.currentIndex) {
        return `${window.location.origin}${this.baseUrl}#pro-team-member-${index + 1}`;
      }

      async shareMember(button) {
        const memberIndex = this.currentIndex;
        const activePanel = this.panels[memberIndex];
        if (!activePanel || !button || button.dataset.busy === 'true') return;
        const memberUrl = this.currentMemberUrl(memberIndex);
        const memberName = activePanel.dataset.memberName || document.title;
        button.dataset.busy = 'true';
        button.setAttribute('aria-disabled', 'true');

        try {
          if (typeof navigator.share === 'function') {
            try {
              await navigator.share({ title: `${memberName} — ${document.title}`, url: memberUrl });
              if (this.currentIndex === memberIndex) {
                this.setShareFeedback(button, button.dataset.sharedLabel || button.dataset.shareLabel);
              }
              return;
            } catch (error) {
              if (error?.name === 'AbortError') return;
            }
          }

          const copied = await this.copyMemberUrl(memberUrl, button);
          if (this.currentIndex !== memberIndex) return;
          const feedback = copied
            ? button.dataset.copiedLabel || button.dataset.shareLabel
            : button.dataset.errorLabel || button.dataset.shareLabel;
          this.setShareFeedback(button, feedback);
        } finally {
          delete button.dataset.busy;
          button.removeAttribute('aria-disabled');
        }
      }

      async copyMemberUrl(memberUrl, button) {
        if (window.isSecureContext && navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(memberUrl);
            return true;
          } catch (error) {
            // Continue with the compatibility fallback below.
          }
        }

        const field = document.createElement('textarea');
        field.value = memberUrl;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }
        field.remove();
        button.focus({ preventScroll: true });
        return copied;
      }

      setShareFeedback(button, nextText) {
        const status = button.parentElement?.querySelector('[data-member-share-status]');
        button.setAttribute('aria-label', nextText);
        if (status) status.textContent = nextText;
        this.swapShareText(button, nextText);
        window.clearTimeout(this.shareResetTimer);
        this.shareResetTimer = window.setTimeout(() => {
          const initialText = button.dataset.shareLabel || '';
          button.setAttribute('aria-label', initialText);
          if (status) status.textContent = '';
          this.swapShareText(button, initialText);
        }, 2400);
      }

      swapShareText(button, nextText) {
        const text = button.querySelector('[data-member-share-text]');
        if (!text || text.textContent === nextText) return;
        window.clearTimeout(this.shareSwapTimer);
        text.classList.remove('is-exit', 'is-enter-start');
        if (this.prefersReducedMotion()) {
          text.textContent = nextText;
          return;
        }

        const rawDuration = getComputedStyle(text).getPropertyValue('--text-swap-dur').trim();
        const duration = rawDuration.endsWith('ms')
          ? Number.parseFloat(rawDuration)
          : Number.parseFloat(rawDuration) * 1000;
        text.classList.add('is-exit');
        this.shareSwapTimer = window.setTimeout(() => {
          text.textContent = nextText;
          text.classList.remove('is-exit');
          text.classList.add('is-enter-start');
          void text.offsetHeight;
          text.classList.remove('is-enter-start');
        }, Number.isFinite(duration) ? duration : 150);
      }

      resetShareFeedback() {
        window.clearTimeout(this.shareSwapTimer);
        window.clearTimeout(this.shareResetTimer);
        this.shareButtons.forEach((button) => {
          const initialText = button.dataset.shareLabel || '';
          const text = button.querySelector('[data-member-share-text]');
          const status = button.parentElement?.querySelector('[data-member-share-status]');
          delete button.dataset.busy;
          button.removeAttribute('aria-disabled');
          button.setAttribute('aria-label', initialText);
          if (text) {
            text.textContent = initialText;
            text.classList.remove('is-exit', 'is-enter-start');
          }
          if (status) status.textContent = '';
        });
      }

      handleKeydown(event) {
        const trigger = event.target.closest('[data-member-trigger]');
        if (this.dataset.page === '1' && trigger) {
          const index = this.triggers.indexOf(trigger);
          let target = null;
          if (event.key === 'ArrowRight') target = this.triggers[this.normalizeTriggerIndex(index + 1)];
          if (event.key === 'ArrowLeft') target = this.triggers[this.normalizeTriggerIndex(index - 1)];
          if (event.key === 'Home') target = this.triggers[0];
          if (event.key === 'End') target = this.triggers[this.triggers.length - 1];
          if (target) {
            event.preventDefault();
            target.focus();
          }
          return;
        }

        if (this.dataset.page !== '2') return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.requestRoster();
        }
        if (event.key === 'ArrowRight' && this.panels.length > 1) {
          event.preventDefault();
          this.navigateMember(this.currentIndex + 1);
        }
        if (event.key === 'ArrowLeft' && this.panels.length > 1) {
          event.preventDefault();
          this.navigateMember(this.currentIndex - 1);
        }
      }

      normalizeTriggerIndex(index) {
        return ((index % this.triggers.length) + this.triggers.length) % this.triggers.length;
      }

      handlePointerDown(event) {
        if (!event.isPrimary) return;
        this.pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }

      handlePointerUp(event) {
        if (!this.pointerStart || event.pointerId !== this.pointerStart.id || this.panels.length <= 1) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(deltaX) < 56 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;
        this.navigateMember(this.currentIndex + (deltaX < 0 ? 1 : -1));
      }

      handleBlockSelect(event) {
        const block = event.target.closest('[data-member-block]');
        if (!block) return;
        const index = Number(block.dataset.memberIndex);
        if (Number.isInteger(index)) this.openMember(index, { historyMode: 'none' });
      }

      memberIndexFromHash() {
        const match = window.location.hash.match(/^#pro-team-member-(\d+)$/);
        if (!match) return null;
        const index = Number(match[1]) - 1;
        return Number.isInteger(index) && index >= 0 && index < this.panels.length ? index : null;
      }

      currentHistoryState() {
        return window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
      }

      writeMemberHistory(mode) {
        if (window.Shopify?.designMode || typeof window.history?.pushState !== 'function') return;
        const currentState = this.currentHistoryState();
        const existingState = currentState.prismProTeam;
        const hasRosterEntry = mode === 'push'
          ? true
          : existingState?.section === this.sectionKey && existingState.hasRosterEntry === true;
        const nextState = {
          ...currentState,
          prismProTeam: {
            section: this.sectionKey,
            memberIndex: this.currentIndex,
            hasRosterEntry,
          },
        };
        const memberUrl = `${this.baseUrl}#pro-team-member-${this.currentIndex + 1}`;
        const method = mode === 'push' ? 'pushState' : 'replaceState';
        window.history[method](nextState, '', memberUrl);
      }

      ownsCurrentHistoryEntry() {
        const memberState = this.currentHistoryState().prismProTeam;
        return memberState?.section === this.sectionKey && memberState.hasRosterEntry === true;
      }

      clearMemberHistory() {
        if (typeof window.history?.replaceState !== 'function') return;
        const nextState = { ...this.currentHistoryState() };
        delete nextState.prismProTeam;
        window.history.replaceState(Object.keys(nextState).length > 0 ? nextState : null, '', this.baseUrl);
      }

      syncFromLocation() {
        const memberIndex = this.memberIndexFromHash();
        if (memberIndex === null) {
          if (this.dataset.page === '2') this.showRoster();
          return;
        }
        this.openMember(memberIndex, { historyMode: 'none' });
      }

      syncHeight() {
        if (!this.stage) return;
        window.requestAnimationFrame(() => {
          const activePage = this.dataset.page === '2' ? this.detailPage : this.rosterPage;
          if (!activePage) return;
          const viewportFloor = Math.max(640, window.innerHeight - 80);
          this.stage.style.minHeight = `${Math.ceil(Math.max(viewportFloor, activePage.scrollHeight))}px`;
        });
      }

      scrollDetailIntoView() {
        const sectionTop = window.scrollY + this.getBoundingClientRect().top;
        const stickyHeader = document.querySelector('.shopify-section-header-sticky');
        const headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
        window.scrollTo({
          top: Math.max(0, sectionTop - headerOffset),
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }

      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }

    customElements.define('prism-pro-team', PrismProTeam);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prism-session-builder"] && !Shopify.designMode) return;
  try {
    
  class PrismSessionBuilder extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-builder-tab]')];
      this.panels = [...this.querySelectorAll('[data-builder-panel]')];
      this.pill = this.querySelector('.t-tabs-pill');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onResize = () => this.movePill(this.activeTab(), false);
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(tab, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
      this.querySelectorAll('[data-builder-stage]').forEach((stage) => this.bindStage(stage));
      requestAnimationFrame(() => this.movePill(this.activeTab(), false));
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.querySelector('.t-tabs'));
    }

    disconnectedCallback() { if (this.resizeObserver) this.resizeObserver.disconnect(); }
    activeTab() { return this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]; }

    movePill(tab, animate) {
      if (!tab || !this.pill) return;
      if (!animate) {
        const previous = this.pill.style.transition;
        this.pill.style.transition = 'none';
        this.pill.style.transform = `translateX(${tab.offsetLeft}px)`;
        this.pill.style.width = `${tab.offsetWidth}px`;
        void this.pill.offsetWidth;
        this.pill.style.transition = previous;
        return;
      }
      this.pill.style.transform = `translateX(${tab.offsetLeft}px)`;
      this.pill.style.width = `${tab.offsetWidth}px`;
    }

    selectTab(tab, animate) {
      if (!tab) return;
      const controlledId = tab.getAttribute('aria-controls');
      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.id !== controlledId; });
      this.movePill(tab, animate && !this.reduceMotion.matches);
    }

    onKeydown(event, index) {
      let target = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      if (event.key === 'Home') target = this.tabs[0];
      if (event.key === 'End') target = this.tabs[this.tabs.length - 1];
      if (!target) return;
      event.preventDefault();
      this.selectTab(target, true);
      target.focus();
    }

    bindStage(stage) {
      const visual = stage.querySelector('[data-builder-visual]');
      if (!visual) return;
      const reset = () => {
        visual.style.setProperty('--builder-rx', '0deg');
        visual.style.setProperty('--builder-ry', '0deg');
      };
      stage.addEventListener('pointermove', (event) => {
        if (this.reduceMotion.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const rect = stage.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        visual.style.setProperty('--builder-rx', `${(-y * 4).toFixed(2)}deg`);
        visual.style.setProperty('--builder-ry', `${(x * 5).toFixed(2)}deg`);
      });
      stage.addEventListener('pointerleave', reset);
      stage.addEventListener('pointercancel', reset);
    }
  }

  if (!customElements.get('prism-session-builder')) customElements.define('prism-session-builder', PrismSessionBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prism-visual-demo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var MIN = 8;
    var MAX = 92;

    function clamp(value) {
      return Math.min(MAX, Math.max(MIN, value));
    }

    function initPrism(root) {
      if (root.getAttribute('data-prism-ready') === 'true') return;

      var comparison = root.querySelector('[data-prism-comparison]');
      var stage = root.querySelector('[data-prism-stage]');
      var handle = root.querySelector('[data-prism-handle]');
      var status = root.querySelector('[data-prism-status]');
      var bar = root.querySelector('.t-tabs');
      var pill = bar ? bar.querySelector('.t-tabs-pill') : null;
      var tabs = bar ? Array.prototype.slice.call(bar.querySelectorAll('.t-tab')) : [];
      var initialX = Number(comparison && comparison.getAttribute('data-initial-x')) || 50;
      var initialY = Number(comparison && comparison.getAttribute('data-initial-y')) || 40;
      var x = initialX;
      var y = initialY;
      var dragging = false;
      var pointerId = null;

      if (!comparison || !stage || !handle || !pill || !tabs.length) return;

      root.setAttribute('data-prism-ready', 'true');

      function activeTab() {
        return tabs.find(function (tab) {
          return tab.getAttribute('aria-selected') === 'true';
        }) || tabs[0];
      }

      function movePill(tab, animate) {
        if (!animate) {
          var previous = pill.style.transition;
          pill.style.transition = 'none';
          pill.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
          pill.style.width = tab.offsetWidth + 'px';
          void pill.offsetWidth;
          pill.style.transition = previous;
          return;
        }
        pill.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        pill.style.width = tab.offsetWidth + 'px';
      }

      function updatePosition() {
        var roundedX = Math.round(x);
        var roundedY = Math.round(y);
        comparison.style.setProperty('--prism-x', roundedX + '%');
        comparison.style.setProperty('--prism-y', roundedY + '%');
        handle.setAttribute('aria-valuenow', String(roundedX));
        handle.setAttribute('aria-valuetext', roundedX + '% horizontal, ' + roundedY + '% vertical');
        if (status) status.textContent = 'Lente situada al ' + roundedX + '% horizontal y ' + roundedY + '% vertical.';
      }

      function setMode(mode, tab, animate) {
        comparison.setAttribute('data-mode', mode);
        tabs.forEach(function (item) {
          var selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });
        handle.setAttribute('tabindex', mode === 'compare' ? '0' : '-1');
        movePill(tab, animate);
        if (status) {
          status.textContent = mode === 'before'
            ? 'Vista sin lente activa.'
            : mode === 'after'
              ? 'Vista con lente activa.'
              : 'Modo de comparación interactiva activo.';
        }
      }

      function moveToPointer(event) {
        var rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        x = clamp(((event.clientX - rect.left) / rect.width) * 100);
        y = clamp(((event.clientY - rect.top) / rect.height) * 100);
        updatePosition();
      }

      function stopDragging(event) {
        if (event && pointerId !== null && event.pointerId !== pointerId) return;
        dragging = false;
        pointerId = null;
        handle.classList.remove('is-dragging');
      }

      function keyboardMove(event) {
        var step = event.shiftKey ? 1 : 4;
        var changed = true;
        switch (event.key) {
          case 'ArrowLeft': x -= step; break;
          case 'ArrowRight': x += step; break;
          case 'ArrowUp': y -= step; break;
          case 'ArrowDown': y += step; break;
          case 'Home': x = MIN; break;
          case 'End': x = MAX; break;
          case 'Escape': x = initialX; y = initialY; break;
          default: changed = false;
        }
        if (changed) {
          event.preventDefault();
          x = clamp(x);
          y = clamp(y);
          updatePosition();
        }
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          setMode(tab.getAttribute('data-prism-view'), tab, true);
        });
        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          tabs[nextIndex].focus();
          setMode(tabs[nextIndex].getAttribute('data-prism-view'), tabs[nextIndex], true);
        });
      });

      handle.addEventListener('pointerdown', function (event) {
        if (event.button !== 0) return;
        event.preventDefault();
        dragging = true;
        pointerId = event.pointerId;
        handle.setPointerCapture(pointerId);
        handle.classList.add('is-dragging');
        moveToPointer(event);
      });

      handle.addEventListener('pointermove', function (event) {
        if (dragging && event.pointerId === pointerId) moveToPointer(event);
      });
      handle.addEventListener('pointerup', stopDragging);
      handle.addEventListener('pointercancel', stopDragging);
      handle.addEventListener('lostpointercapture', stopDragging);
      handle.addEventListener('keydown', keyboardMove);

      stage.addEventListener('pointerdown', function (event) {
        if (event.button !== 0 || event.target === handle || handle.contains(event.target)) return;
        var compareTab = tabs.find(function (tab) {
          return tab.getAttribute('data-prism-view') === 'compare';
        });
        if (comparison.getAttribute('data-mode') !== 'compare' && compareTab) {
          setMode('compare', compareTab, true);
        }
        moveToPointer(event);
        handle.focus({ preventScroll: true });
      });

      window.addEventListener('resize', function () {
        movePill(activeTab(), false);
      });

      updatePosition();
      requestAnimationFrame(function () {
        movePill(activeTab(), false);
      });
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-prism-root]').forEach(initPrism);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }());

  (function () {
    'use strict';

    function initPrismEnhancements(root) {
      if (root.getAttribute('data-prism-enhanced') === 'true') return;

      var comparison = root.querySelector('[data-prism-comparison]');
      var stage = root.querySelector('[data-prism-stage]');
      var handle = root.querySelector('[data-prism-handle]');
      var home = root.querySelector('[data-prism-home]');
      var dialog = root.querySelector('[data-prism-dialog]');
      var dialogSlot = root.querySelector('[data-prism-dialog-slot]');
      var openDialog = root.querySelector('[data-prism-open-dialog]');
      var sticky = root.querySelector('[data-prism-sticky]');
      var stickyBoundaries = Array.prototype.slice.call(document.querySelectorAll('[data-prism-family], footer'));
      var addButtons = Array.prototype.slice.call(root.querySelectorAll('[data-prism-add]'));
      var trackingLinks = Array.prototype.slice.call(root.querySelectorAll('[data-prism-track]'));
      var jumpLinks = Array.prototype.slice.call(document.querySelectorAll('[data-prism-demo-jump]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.t-tab'));
      var originalButton = document.querySelector('.product__info-container form[data-type="add-to-cart-form"] button[name="add"]');
      var productId = root.getAttribute('data-product-id') || '';
      var productHandle = root.getAttribute('data-product-handle') || '';
      var demoUsed = false;
      var interactionTracked = false;
      var forwardedSource = '';
      var previousFocus = null;

      if (!comparison || !stage || !handle || !home) return;
      root.setAttribute('data-prism-enhanced', 'true');

      function publish(action, detail) {
        var payload = Object.assign({
          action: action,
          product_id: productId,
          product_handle: productHandle,
          demo_used: demoUsed
        }, detail || {});

        document.dispatchEvent(new CustomEvent('prism:interaction', { detail: payload }));

        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: 'prism_interaction' }, payload));
        }

        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          try {
            var result = window.Shopify.analytics.publish('prism_lens:interaction', payload);
            if (result && typeof result.catch === 'function') result.catch(function () {});
          } catch (error) {
            /* Analytics must never interrupt the shopping experience. */
          }
        }
      }

      function markDemoUsed(action, detail) {
        demoUsed = true;
        handle.classList.remove('is-onboarding');
        try {
          window.sessionStorage.setItem('prism_demo_used:' + productId, '1');
        } catch (error) {
          /* Storage can be unavailable in privacy modes. */
        }
        publish(action, detail);
      }

      function trackFirstInteraction(action, detail) {
        if (interactionTracked) return;
        interactionTracked = true;
        markDemoUsed(action, detail);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          markDemoUsed('mode_change', { mode: tab.getAttribute('data-prism-view') });
        });
      });

      handle.addEventListener('pointerdown', function () {
        trackFirstInteraction('comparison_drag', { input: 'pointer' });
      });
      handle.addEventListener('keydown', function (event) {
        if (event.key.indexOf('Arrow') === 0 || event.key === 'Home' || event.key === 'End') {
          trackFirstInteraction('comparison_drag', { input: 'keyboard' });
        }
      });
      stage.addEventListener('pointerdown', function () {
        trackFirstInteraction('comparison_position', { input: 'pointer' });
      });

      window.setTimeout(function () {
        handle.classList.remove('is-onboarding');
      }, 5200);

      trackingLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          publish(link.getAttribute('data-prism-track') || 'outbound_link');
        });
      });

      jumpLinks.forEach(function (link) {
        if (link.getAttribute('data-prism-jump-ready') === 'true') return;
        link.setAttribute('data-prism-jump-ready', 'true');
        link.addEventListener('click', function () {
          markDemoUsed('demo_jump', { source: 'product_info' });
          window.requestAnimationFrame(function () {
            root.focus({ preventScroll: true });
          });
        });
      });

      function closeDialog() {
        if (dialog && dialog.open) dialog.close();
      }

      if (dialog && dialogSlot && openDialog && typeof dialog.showModal === 'function') {
        openDialog.addEventListener('click', function () {
          var compareTab = tabs.find(function (tab) {
            return tab.getAttribute('data-prism-view') === 'compare';
          });
          if (compareTab && compareTab.getAttribute('aria-selected') !== 'true') compareTab.click();
          previousFocus = document.activeElement;
          dialog.showModal();
          dialogSlot.appendChild(comparison);
          document.body.classList.add('prism-dialog-open');
          updateSticky();
          handle.classList.remove('is-onboarding');
          publish('fullscreen_open');
          var closeButton = dialog.querySelector('.prism-dialog__close');
          if (closeButton) closeButton.focus({ preventScroll: true });
        });

        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog();
        });

        dialog.addEventListener('close', function () {
          home.appendChild(comparison);
          document.body.classList.remove('prism-dialog-open');
          publish('fullscreen_close');
          if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
        });
      } else if (openDialog) {
        openDialog.hidden = true;
      }

      function syncCartButtons() {
        var unavailable = !originalButton || originalButton.disabled;
        addButtons.forEach(function (button) {
          button.disabled = unavailable;
          var label = button.querySelector('[data-prism-cart-label]');
          if (!label) return;
          label.textContent = unavailable ? 'Agotado' : (button.getAttribute('data-prism-add-source') === 'sticky' ? 'Añadir' : 'Añadir al carrito');
        });
      }

      addButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!originalButton || originalButton.disabled) return;
          forwardedSource = button.getAttribute('data-prism-add-source') || 'demo';
          originalButton.click();
        });
      });

      if (originalButton) {
        originalButton.addEventListener('click', function () {
          publish('add_to_cart_intent', {
            source: forwardedSource || 'product_form',
            demo_used: demoUsed
          });
          forwardedSource = '';
        });
        new MutationObserver(syncCartButtons).observe(originalButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled']
        });
      }
      syncCartButtons();

      function stickyBoundaryNearby() {
        if (!sticky || !stickyBoundaries.length) return false;

        var lead = sticky.getBoundingClientRect().height;
        return stickyBoundaries.some(function (boundary) {
          var rect = boundary.getBoundingClientRect();
          return rect.top < window.innerHeight + lead && rect.bottom > -lead;
        });
      }

      function updateSticky() {
        if (!sticky || !originalButton) return;
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var originalPassed = originalButton.getBoundingClientRect().bottom < 0;
        var visible = mobile && originalPassed && !stickyBoundaryNearby() && !originalButton.disabled && !(dialog && dialog.open);
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        sticky.inert = !visible;
        document.body.classList.toggle('prism-sticky-visible', visible);
      }

      var stickyFrame = 0;
      function requestStickyUpdate() {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(function () {
          stickyFrame = 0;
          updateSticky();
        });
      }

      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate);
      if (dialog) {
        dialog.addEventListener('close', updateSticky);
        dialog.addEventListener('cancel', updateSticky);
      }
      updateSticky();
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-prism-root]').forEach(initPrismEnhancements);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
